export default {
  setFusionAuthToken(context, payload) {
    context.commit('setFusionAuthToken', payload)
  },
  setIsShopManager(context, payload) {
    context.commit('setIsShopManager', payload)
  },
  setIsCustomerService(context, payload) {
    context.commit('setIsCustomerService', payload)
  },
  setIsAdmin(context, payload) {
    context.commit('setIsAdmin', payload)
  },
  setIsOctipasAdmin(context, payload) {
    context.commit('setIsOctipasAdmin', payload)
  },
  setCurrentGroup(context, payload) {
    context.commit('setCurrentGroup', payload)
  },
  setCurrentStore(context, payload) {
    context.commit('setCurrentStore', payload)
  },
  setCurrentStoreDetails(context, payload) {
    context.commit('setCurrentStoreDetails', payload)
  },
  setRoles(context, payload) {
    context.commit('setRoles', payload)
  },
  setRolesUnifiedStock(context, payload) {
    context.commit('setRolesUnifiedStock', payload)
  },
  setRolesOctiStock(context, payload) {
    context.commit('setRolesOctiStock', payload)
  },
  setRolesAnalytics(context, payload) {
    context.commit('setRolesAnalytics', payload)
  },
  setPreviousPath(context, payload) {
    context.commit('setPreviousPath', payload)
  },
  setPartnerSettings(context, payload) {
    context.commit('setPartnerSettings', payload)
  },
  setUserEmail(context, payload) {
    context.commit('setUserEmail', payload)
  },
  setUsername(context, payload) {
    context.commit('setUsername', payload)
  },
  setIsDark(context, payload) {
    context.commit('setIsDark', payload)
  },
  setBreadcrumbs(context, payload) {
    context.commit('setBreadcrumbs', payload)
  },
  updateBreadcrumb(context, payload) {
    context.commit('updateBreadcrumb', payload)
  },
  setCurrentTab(context, payload) {
    context.commit('setCurrentTab', payload)
  },
  setUserStores(context, payload) {
    context.commit('setUserStores', payload)
  },
  setAiEnabled(context, payload) {
    context.commit('setAiEnabled', payload)
  },
  setPartnerTheme(context, payload) {
    context.commit('setPartnerTheme', payload)
  },
  setDisplayNavigation(context, payload) {
    context.commit('setDisplayNavigation', payload)
  },
  setLocale(context, payload) {
    context.commit('setLocale', payload)
  },
}
